import { render } from "./Wishlists.vue?vue&type=template&id=69f951fe&scoped=true"
import script from "./Wishlists.vue?vue&type=script&lang=ts"
export * from "./Wishlists.vue?vue&type=script&lang=ts"

import "./Wishlists.vue?vue&type=style&index=0&id=69f951fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69f951fe"

export default script